import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/70">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-xl font-semibold text-foreground-900 cursor-pointer whitespace-nowrap">
              校园春色
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              用镜头和文字，记录青春校园里最美好的四季风光与青春故事，让每一帧校园春色都成为永恒的记忆。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">内容分类</h4>
            <div className="flex flex-col gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">快速链接</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors">关于我们</Link>
              <Link to="/category/scenery" className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors">四季风光</Link>
              <Link to="/category/stories" className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer whitespace-nowrap transition-colors">青春故事</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">关注我们</h4>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微信公众号">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
            </div>
            <p className="mt-4 text-sm text-foreground-500">
              联系邮箱：hello@qinglanriyu.cn
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2023-2026 校园春色. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 cursor-pointer whitespace-nowrap transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 cursor-pointer whitespace-nowrap transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}